import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoaderService } from '@shared/services/loader/loader.service';
import { finalize, tap } from 'rxjs';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {

  const loaderService = inject(LoaderService);
  
  let isDisabled = false;
  
  // Subscribe to the LoaderService observable to get the latest value of isDisabled
  loaderService.isDisabled$.pipe(
    tap(disabled => isDisabled = disabled)
  ).subscribe();

  // Manage the request counter within the interceptor
  loaderService.totalRequests++;
  
  if (!isDisabled) {
    loaderService.setLoading(true);
  }

  return next(req).pipe(
    finalize(() => {
      loaderService.totalRequests--;
      if (loaderService.totalRequests === 0 && !isDisabled) {
        loaderService.setLoading(false);
      }
    })
  );
};
